import { Link } from '@solidjs/meta';

export function Anton()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Anton&display=swap' rel='stylesheet' />
	</>);
}

